import { Injectable } from '@angular/core';

import { Observable, Subject, of } from 'rxjs';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { ControlPropertyHandler } from './control-property-handler';
import { AbstractPropertyEditor } from '../types';

@Injectable({
  providedIn: 'root'
})
export class ElementIdPropertyService implements ControlPropertyHandler<any> {
  propertyName: string = 'id';

  constructor(private commonConfig: DynamicFormCommonConfig) {}

  handleData(data: any, editor: AbstractPropertyEditor): Observable<any> {
    const sub = new Subject<string>();
    if (data && editor.settings.reg) {
      const reg = editor.settings.reg;
      if (!reg.test(data)) {
        this.commonConfig.log.error(`åç´ Idå¿é¡»ä»¥å­æ¯å¼å¤´,å­æ¯åæ°å­ç»å`);
        sub.error('');
        sub.complete();
        return sub;
      }
    }
    return of(data);
  }
}
